import {useEffect, useState} from 'react'

export function useParams() {
  const [params, setParams] = useState<[string, string][]>([])
  useEffect(() => {
    const searchParams = new URLSearchParams(typeof window === 'undefined' ? '' : window.location.search)
    const newParams: [string, string][] = []

    for (const [key, value] of searchParams.entries()) {
      if (key.startsWith('utm_') || key === 'gclid' || key === 'fbclid' || key === 'user_login_creator') {
        newParams.push([key, value])
      }
    }

    setParams(newParams)
  }, [])

  return {params}
}
